import { jsPDF } from 'jspdf';

async function loadFont(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function getBase64ImageFromUrl(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function loadImage(base64Str) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = base64Str;
  });
}

const PROJECT_FIELD_LABELS = {
  firstName: 'First Name',
  lastName: 'Last Name',
  companyName: 'Company Name',
  phoneNumber: 'Phone Number',
  email: 'Email Address',
  projectName: 'Project Name',
  chosenService: 'Chosen Service',
  status: 'Status',
  serviceSelection: 'Service Selection',
  campaignObjective: 'Campaign Objective',
  countries: 'Countries',
  cities: 'Cities',
  ageRange: 'Age Range',
  gender: 'Gender',
  keywords: 'Keywords',
  approximateBudget: 'Approximate Budget',
  currency: 'Currency',
  targetAudienceDescription: 'Target Audience Description',
  contactDatabase: 'Contact Database',
  additionalMessage: 'Additional Message',
  graphicService: 'Graphic Service',
  graphicDescription: 'Graphic Description',
  graphicWebsite1: 'Graphic Website 1',
  graphicWebsite2: 'Graphic Website 2',
  graphicWebsite3: 'Graphic Website 3',
  price: 'Price',
};

function isEmptyValue(v) {
  if (v === null || v === undefined) return true;
  if (Array.isArray(v) && v.length === 0) return true;
  if (typeof v === 'string' && v.trim() === '') return true;
  return false;
}

export async function downloadRequestProjectPdf(selectedRequest) {
  if (!selectedRequest) return;

  const doc = new jsPDF();
  const origin = window.location.origin;

  const fontUrl = `${origin}/fonts/DejaVuSans.ttf`;
  const fontDataUrl = await loadFont(fontUrl);
  const fontBase64 = fontDataUrl.split(',')[1];
  doc.addFileToVFS('DejaVuSans.ttf', fontBase64);
  doc.addFont('DejaVuSans.ttf', 'DejaVuSans', 'normal');
  doc.setFont('DejaVuSans');

  const logoUrl = `${origin}/images/logo1.png`;
  const logoBase64 = await getBase64ImageFromUrl(logoUrl);
  const logoImg = await loadImage(logoBase64);
  const ratio = logoImg.naturalWidth / logoImg.naturalHeight;
  const desiredWidth = 40;
  const desiredHeight = desiredWidth / ratio;
  doc.addImage(logoBase64, 'PNG', 10, 10, desiredWidth, desiredHeight);

  let currentY = 10 + desiredHeight + 10;

  doc.setFontSize(16);
  doc.text('Project Details', 10, currentY);
  currentY += 10;

  doc.setFontSize(12);

  for (const [field, label] of Object.entries(PROJECT_FIELD_LABELS)) {
    const value = selectedRequest[field];
    if (isEmptyValue(value)) continue;
    const displayValue = Array.isArray(value) ? value.join(', ') : String(value);
    doc.text(`${label}: ${displayValue}`, 10, currentY);
    currentY += 10;
    if (currentY > doc.internal.pageSize.getHeight() - 10) {
      doc.addPage();
      doc.setFont('DejaVuSans', 'normal');
      currentY = 20;
    }
  }

  const pdfName = selectedRequest.projectName || 'project';
  doc.save(`${pdfName}.pdf`);
}

export function downloadRequestHistoryPdf(selectedRequest) {
  if (!selectedRequest?.history) return;

  const doc = new jsPDF();
  doc.setFontSize(12);

  let yPosition = 20;
  const leftMargin = 10;
  const boxWidth = 190;
  const boxPadding = 5;
  const lineHeight = 6;
  const pageHeight = doc.internal.pageSize.height;

  selectedRequest.history.forEach((entry) => {
    const dateString = new Date(entry.timestamp).toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const changedByLine = `${entry.changedBy || 'Unknown user'} \u2022 ${dateString}`;

    const splittedChanges = (entry.changes || '').split(', ');
    const changesText = splittedChanges.join('\n');

    const changedByLines = doc.splitTextToSize(changedByLine, boxWidth - 2 * boxPadding);
    const changesLines = doc.splitTextToSize(changesText, boxWidth - 2 * boxPadding);

    const blockHeight =
      (changedByLines.length + changesLines.length) * lineHeight + 2 * boxPadding;

    if (yPosition + blockHeight + 10 > pageHeight) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFillColor(245, 245, 245);
    doc.roundedRect(leftMargin, yPosition, boxWidth, blockHeight, 2, 2, 'F');

    doc.setTextColor(0, 0, 0);
    let textY = yPosition + boxPadding + lineHeight;
    changedByLines.forEach((line) => {
      doc.text(line, leftMargin + boxPadding, textY);
      textY += lineHeight;
    });
    changesLines.forEach((line) => {
      doc.text(line, leftMargin + boxPadding, textY);
      textY += lineHeight;
    });

    yPosition += blockHeight + 5;
  });

  doc.save('change-history.pdf');
}
